export default __webpack_public_path__ + "3f15d8bebbd4558d7b3ea219f36f285a.png";